import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import fieldNames from '../constants/field-names';
import createExternalValidator from '../validators/create-external-validator';

const { InputGroupField, CheckboxField, Stack } = designSystem;

function ExternalField({ control, onChange, onClick }) {
  const handleUrlChange = useCallback(
    (value) => {
      onChange({
        fieldName: fieldNames.EXTERNAL_URL,
        fieldValue: value,
      });
    },
    [onChange]
  );

  const handleUrlClick = useCallback(() => {
    onClick({ fieldName: fieldNames.EXTERNAL_URL });
  }, [onClick]);

  const handleTargetBlankChange = useCallback(
    (value) => {
      onChange({
        fieldName: fieldNames.EXTERNAL_TARGET_BLANK_SWITCHER,
        fieldValue: value,
      });
    },
    [onChange]
  );

  const handleNofollowChange = useCallback(
    (value) => {
      onChange({
        fieldName: fieldNames.EXTERNAL_NOFOLLOW_SWITCHER,
        fieldValue: value,
      });
    },
    [onChange]
  );

  return (
    <Stack gap="spacing-2-xs">
      <div>
        <InputGroupField
          name={fieldNames.EXTERNAL_URL}
          control={control}
          rules={{ validate: createExternalValidator() }}
          placeholder="https://example.com"
          onChange={handleUrlChange}
          onClick={handleUrlClick}
        />
      </div>
      <CheckboxField
        name={fieldNames.EXTERNAL_TARGET_BLANK_SWITCHER}
        control={control}
        label={i18next.t('Open in a new tab')}
        onChange={handleTargetBlankChange}
      />
      <CheckboxField
        name={fieldNames.EXTERNAL_NOFOLLOW_SWITCHER}
        control={control}
        label={i18next.t('Add a Nofollow tag')}
        onChange={handleNofollowChange}
        tooltipProps={{
          id: 'nofollow-control',
          placement: 'bottom',
          text: i18next.t(
            'The Nofollow tag tells search engines to ignore this link so that it does not impact search engine rank for the target website'
          ),
        }}
      />
    </Stack>
  );
}

ExternalField.propTypes = {
  control: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ExternalField;
